module.exports = __webpack_public_path__ + "img/about-m-slide-13.9aafc24e.jpg";